import { useSyncExternalStore } from "react";

// Одна постоянная живая область меню (`role="status"`, вежливая): итоги, которые
// человек иначе не услышит, — «З'явилось 2 нових справи» (плашка раскрылась сама,
// фокус не двигается) и «Пункт: додано в обране» (звёздочка убрала строку из
// списка). ⚠ Область стоит в меню всегда и пуста до первого сообщения: новая
// область, появившаяся вместе с текстом, чтецами не озвучивается.

let said = "";
let flip = false;
const listeners = new Set<() => void>();

/** Сказать чтецу. Повтор той же фразы подряд тоже озвучивается: хвост-пробел меняется. */
export function announce(text: string): void {
  flip = !flip;
  said = flip ? text : `${text} `;
  for (const one of listeners) one();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function LiveRegion() {
  const text = useSyncExternalStore(subscribe, () => said, () => said);
  return (
    <p role="status" aria-live="polite" className="sr-only">
      {text}
    </p>
  );
}
